import React, {useState, useEffect} from 'react';
import BarraNavegacao from "../components/BarraNavegacao";
import LogoWebSai from '../assets/logo.png';
import Table from 'react-bootstrap/Table';
import { MdEditSquare } from "react-icons/md";
import Swal from 'sweetalert2'
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import dayjs from 'dayjs';
import Select from 'react-select';
import Modal from 'react-bootstrap/Modal';
import { RotatingLines } from 'react-loader-spinner';
import { BiSearch,BiTrash } from "react-icons/bi";
import axios from 'axios';

export default function Edicoes() {

    useEffect(()=>{
        consultarPesquisas();
        preencherFormularios();
        preencherGrupos();
    }, []);

    const [inputs, setInputs] = useState({});
    const [error, setErrors] = useState({});
    const [pesquisas, setPesquisas] = useState([]);
    const [pesquisaFilter, setPesquisaFilter] = useState([]);
    const [loading, setLoad] = useState(true);
    const [loadingListaForm, setLoadListaForm] = useState(false);
    const [loadTableForm, setLoadTableForm] = useState("");
    //const [msg, setMsg] = useState('');
    const [modal, setModal] = useState(false);
    const [modalAplicacao, setModalAplicacao] = useState(false);
    const [modalEdicao, setModalEdicao] = useState(false);
    const [formularios, setFormularios] = useState([]);
    const [formulariosFilter, setFormulariosFilter] = useState([]);
    const [tituloEdicao, setTituloEdicao] = useState("");

    const [selectedOptionGrupo, setSelectedOptionGrupo] = useState(null);
    const [selectedOptionForm, setSelectedOptionForm] = useState(null);
    const [listaFormularios, setListaFormularios] = useState([]);
    const [isUpdate, setIsUpdate] = useState(false);
    const [edicaoId, setEdicaoId] = useState("");
    const [vigente, setVigente] = useState(false);
    const [dtAtual,setDtAtual] = useState(new Date());
    const [todos, setTodos] = useState(true);

    const [listaGrupos, setListaGrupos] = useState([]);
    const [loadingListaGrupos, setLoadListaGrupos] = useState(false);
    

    const handledChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        if(name === 'ativo') {
            if(value === 'true') setInputs(values => ({...values,[name]:true}));
            else setInputs(values => ({...values,[name]:false}));
        }
        else if(name === 'homologacao') {
            if(value === 'true') setInputs(values => ({...values,[name]:true}));
            else setInputs(values => ({...values,[name]:false}));
        }
        else if(name === 'vigente') {
            if(value === 'true') setInputs(values => ({...values,[name]:true}));
            else setInputs(values => ({...values,[name]:false}));
        }
        else if(name === 'anoEdicao' && inputs.edicaoId === null){
            let descricao = "Websai-" + value;
            setInputs(values => ({...values,descricao:descricao}));
            setInputs(values => ({...values,[name]:value}))
        }
        else if(name === 'anoEdicao' && inputs.edicaoId !== null){
            let descricao = "Websai-" + value;
            setInputs(values => ({...values,descricao:descricao}));
            setInputs(values => ({...values,[name]:value}))
        }
        else setInputs(values => ({...values,[name]:value}));
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        if(isUpdate) update();
        else save();
    }

    const submitEdicao = (event) => {
        event.preventDefault();
        if(inputs.edicaoId === null) {
            saveEdicao();
        }
        else {
            updateEdicao();
        }
    }

    const consultarPesquisas = () =>
    {
        axios.get(process.env.REACT_APP_API + 'Edicoes', {headers:{Authorization:"Bearer "+sessionStorage.getItem('token')}})
        .then(function(response) {
            if(response.status !== 200) {
                sessionStorage.clear();
                window.location.href = process.env.REACT_APP_HOST+"login";
                return;
            }
            setPesquisas(response.data.value);
            //setPesquisaFilter(response.data.value);

            //filtrando apenas vigentes
            var updatedList = response.data.value;
            const filtered = updatedList.filter(item => item.vigente === true);
            setPesquisaFilter(filtered);

            setLoad(false);
        }).catch((error) => {
            sessionStorage.clear();
            window.location.href = process.env.REACT_APP_HOST+"login";
        })
    }

    const consultarFormularios = (edicaoId) =>
    {
        setLoadTableForm("");
        setFormularios([]);
        setFormulariosFilter([]);
        let jsonEdicaoId = {edicaoId:edicaoId}
        axios.post(process.env.REACT_APP_API + 'FormularioGrupos/Generico',jsonEdicaoId, {headers:{Authorization:"Bearer "+sessionStorage.getItem('token')}})
        .then(function(response) {
            if(response.status !== 200) {
                sessionStorage.clear();
                window.location.href = process.env.REACT_APP_HOST+"login";
                return;
            }

            if(response.data.statusCode !== 400) {
                setFormularios(response.data.value);
                setFormulariosFilter(response.data.value);
            }
            setLoadTableForm("d-none");
        }).catch((error) => {
            sessionStorage.clear();
            window.location.href = process.env.REACT_APP_HOST+"login";
        })
    }

    const editPesquisa = (pesquisa) => {
        setTituloEdicao(pesquisa.descricao);
        controleModal(true);
        consultarFormularios(pesquisa.edicaoId)
        setEdicaoId(pesquisa.edicaoId);
        setVigente(pesquisa.vigente);
    }

    const save = () => {
        if(!selectedOptionGrupo) { setErrors({grupo:"Selecione o grupo"}); return; }
        if(!selectedOptionForm) { setErrors({formulario:"Selecione o formulário"}); return; }
        if(inputs.dtInicio === null) { setErrors({dtInicio:"Preencha o início da pesquisa"}); return; }
        if(inputs.dtFim === null) { setErrors({dtFim:"Preencha o término da pesquisa"}); return; }
        if(selectedOptionForm) { inputs.formulario.formularioId = selectedOptionForm.value; }
        if(selectedOptionGrupo) { inputs.sistemaGrupo.sistemaGrupoId = selectedOptionGrupo.value; }

        let dadosInput = {
            dtInicio: inputs.dtInicio,
            dtFim: inputs.dtFim,
            homologacao: true,
            edicaoId: edicaoId,
            formularioId: inputs.formulario.formularioId,
            sistemaGrupoId: inputs.sistemaGrupo.sistemaGrupoId,
            ativo: true
          }
      
        axios.post(process.env.REACT_APP_API + 'FormularioGrupos',dadosInput, {headers:{Authorization:"Bearer "+sessionStorage.getItem('token')}})
        .then((response => {
            if(response.status !== 200) {
                sessionStorage.clear();
                window.location.href = process.env.REACT_APP_HOST+"login";
                return;
            }
            consultarFormularios(edicaoId);
            setModalAplicacao(false);
            setModal(true);
            Swal.fire({
                title: 'Dados gravados com sucesso!',
                icon: 'success',
                showConfirmButton: false,
                timer: 2000
            }) 
        })).catch((error) => {
            sessionStorage.clear();
             window.location.href = process.env.REACT_APP_HOST+"login";
        });
    }

    const saveEdicao = () => {
        if(inputs.descricao === null) { setErrors({descricao:"Preencha o título da edição"}); return; }
        if(inputs.anoEdicao === null) { setErrors({anoEdicao:"Preencha o ano da edição"}); return; }

        Swal.fire({
            title: 'Aguarde...',
            showConfirmButton: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        })

        axios.post(process.env.REACT_APP_API + 'Edicoes',inputs, {headers:{Authorization:"Bearer "+sessionStorage.getItem('token')}})
        .then((response => {
            if(response.status !== 200) {
                sessionStorage.clear();
                window.location.href = process.env.REACT_APP_HOST+"login";
                return;
            }

            if(response.data.statusCode === 400) {
                Swal.close();
                Swal.fire({
                    title: 'Não foi possível gravar',
                    text: response.data.value.message,
                    icon: 'warning',
                    showConfirmButton: false,
                    showCancelButton: true,
                    cancelButtonText:'Fechar'
                })
            }
            else {
                setModalEdicao(false);
                consultarPesquisas();
                Swal.close();
            }
        })).catch((error) => {
            sessionStorage.clear();
            window.location.href = process.env.REACT_APP_HOST+"login";
        });
    }

    const updateEdicao = () => {
        if(inputs.descricao === null) { setErrors({descricao:"Preencha o título da edição"}); return; }
        if(inputs.anoEdicao === null) { setErrors({anoEdicao:"Preencha o ano da edição"}); return; }
      
        Swal.fire({
            title: 'Aguarde...',
            showConfirmButton: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        })
        
        axios.put(process.env.REACT_APP_API + 'Edicoes/'+inputs.edicaoId,inputs, {headers:{Authorization:"Bearer "+sessionStorage.getItem('token')}})
        .then((response => {
            if(response.status !== 200) {
                sessionStorage.clear();
                window.location.href = process.env.REACT_APP_HOST+"login";
                return;
            }
            if(response.data.statusCode === 400) {
                Swal.close();
                Swal.fire({
                    title: 'Não foi possível gravar',
                    text: response.data.value.message,
                    icon: 'warning',
                    showConfirmButton: false,
                    showCancelButton: true,
                    cancelButtonText:'Fechar'
                })
            }
            else {
                setModalEdicao(false);
                consultarPesquisas();
                Swal.close();
            }
        })).catch((error) => {
            sessionStorage.clear();
            window.location.href = process.env.REACT_APP_HOST+"login";
        });
    }

    const update = () => {
        if(inputs.dtInicio === null) { setErrors({dtInicio:"Preencha o início da pesquisa"}); return; }
        if(inputs.dtFim === null) { setErrors({dtFim:"Preencha o término da pesquisa"}); return; } 
        if(selectedOptionForm) inputs.formulario.formularioId = selectedOptionForm.value;

        let dadosInput = {
            dtInicio: inputs.dtInicio,
            dtFim: inputs.dtFim,
            homologacao: inputs.homologacao,
            edicaoId: inputs.edicao.edicaoId,
            formularioId: inputs.formulario.formularioId,
            sistemaGrupoId: inputs.sistemaGrupo.sistemaGrupoId,
            ativo: inputs.ativo
          }

        axios.put(process.env.REACT_APP_API + 'FormularioGrupos/'+inputs.formularioGrupoId,dadosInput, {headers:{Authorization:"Bearer "+sessionStorage.getItem('token')}})
        .then((response => {
            if(response.status !== 200) {
                sessionStorage.clear();
                window.location.href = process.env.REACT_APP_HOST+"login";
                return;
            }
            consultarFormularios(inputs.edicao.edicaoId);
            setModalAplicacao(false);
            setModal(true);
            Swal.fire({
                title: 'Dados gravados com sucesso!',
                icon: 'success',
                showConfirmButton: false,
                timer: 2000
            })
        })).catch((error) => {
            sessionStorage.clear();
            window.location.href = process.env.REACT_APP_HOST+"login";
        });
    }

    const delFormGrupo = (formularioGrupoId) => {
        Swal.fire({
            title: "Tem certeza?",
            text: "Isso irá interferir nas aplicações realizadas",
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Sim",
            cancelButtonText: "Não"
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Aguarde...',
                    showConfirmButton: false,
                    didOpen: () => {
                        Swal.showLoading();

                        axios.delete(process.env.REACT_APP_API + 'Formularios/ExcluirFormularioGrupo/'+formularioGrupoId, {headers:{Authorization:"Bearer "+sessionStorage.getItem('token')}})
                        .then((response => {
                            if(response.status !== 200) {
                                sessionStorage.clear();
                                window.location.href = process.env.REACT_APP_HOST+"login";
                                return;
                            }
                            Swal.close();
                            consultarFormularios(edicaoId);
                        })).catch((error) => {
                            sessionStorage.clear();
                            window.location.href = process.env.REACT_APP_HOST+"login";
                        });

                    }
                })
            }
          });

    }

    const limparCampos = () => {
        setErrors({});
    }

    const searchPesquisas = (event) => {
        let exibicao = pesquisas;
        if(todos) {
            exibicao = exibicao.filter(item => item.vigente === true);
        }

        var updatedList = [...exibicao];
        const filtered = updatedList.filter(item => {
            return item.descricao.toLowerCase().indexOf(event.target.value.toLowerCase()) !== -1
        });
        setPesquisaFilter(filtered);
    }

    const searchPesquisasForms = (event) => {
        var updatedList = [...formularios];
        const filtered = updatedList.filter(item => {
            return item.sistemaGrupo.descricao.toLowerCase().indexOf(event.target.value.toLowerCase()) !== -1
        });
        setFormulariosFilter(filtered);
    }

    const controleModal = (state) => {
        setModal(state);
    }

    const controleModalAplicacao = (state,index, update) => {
        if(state)
        {
            limparCampos();
            setModal(false)
            if(update) {
                setIsUpdate(true);
                setInputs(formularios[index]);
            }
            else {
                setIsUpdate(false);
                setInputs({
                    ativo:true,
                    dtFim:null,
                    dtInicio:null,
                    formulario:{
                        formularioId:null,
                        titulo:null
                    },
                    formularioGrupoId:null,
                    homologacao:true,
                    sistemaGrupo:{
                        sistemaGrupoId:null,
                        descricao:null
                    }
                })
            }
        }
        else 
        {
            setModal(true)
        }
        setModalAplicacao(state);
    }    

    const preencherFormularios = () =>
    {
        setLoadListaForm(true);
        axios.get(process.env.REACT_APP_API + 'Formularios',{headers:{Authorization:"Bearer "+sessionStorage.getItem('token')}})
        .then(function(response) {
            if(response.status !== 200) {
                sessionStorage.clear();
                window.location.href = process.env.REACT_APP_HOST+"login";
                return;
            }
            setLoadListaForm(false);
            response.data.value.forEach((item) => {
                setListaFormularios(listaFormularios => [...listaFormularios,{label:item.titulo, value:item.formularioId}]);
            })
        }).catch((error) => {
            sessionStorage.clear();
            window.location.href = process.env.REACT_APP_HOST+"login";
        })
    }

    const preencherGrupos = () =>
    {
        setLoadListaGrupos(true);
        axios.get(process.env.REACT_APP_API + 'FormularioGrupos',{headers:{Authorization:"Bearer "+sessionStorage.getItem('token')}})
        .then(function(response) {
            if(response.status !== 200) {
                sessionStorage.clear();
                window.location.href = process.env.REACT_APP_HOST+"login";
                return;
            }
            setLoadListaGrupos(false);
            let listaGrupos = [];
            response.data.value.forEach((item) => {
                listaGrupos.push({label:item.sistemaGrupo.descricao, value:item.sistemaGrupo.sistemaGrupoId})
                //setListaGrupos(listaGrupos => [...listaGrupos,{label:item.sistemaGrupo.descricao, value:item.sistemaGrupo.sistemaGrupoId}]);
            })
            setListaGrupos(listaGrupos);
        }).catch((error) => {
            sessionStorage.clear();
            window.location.href = process.env.REACT_APP_HOST+"login";
        })
    }

    const trocarExibir = () => {
        if(todos) {
            setPesquisaFilter(pesquisas);
            setTodos(false); 
        }
        else {
            //selecionando apenas vigentes
            var updatedList = pesquisas;
            const filtered = updatedList.filter(item => item.vigente === true);
            setPesquisaFilter(filtered);
            setTodos(true);
        }
    }

    function compareDates (date) {
        let parts = date.split('/') // separa a data pelo caracter '/'
        let today = new Date()      // pega a data atual
        
        date = new Date(parts[2], parts[1] - 1, parts[0]) // formata 'date'
        
        // compara se a data informada é maior que a data atual
        // e retorna true ou false
        return date >= today ? true : false
    }

    const controleModalEdicao = (state) => {
        setModalEdicao(state);
    }

    const editEdicao = (edicao) => {
        setErrors({});
        setInputs(edicao);
        controleModalEdicao(true);
    }

    const adicionarNovaEdicao = () => {
        setInputs({
            edicaoId:null,
            anoEdicao:null,
            anoEgresso:null,
            descricao:"Websai-",
            dtInicioEgresso:null,
            dtFimEgresso:null,
            regLock:false,
            vigente:true,
            ativo:true
        });
        controleModalEdicao(true);
    }

    return (
        <div> 
            <BarraNavegacao/>
            <div className="container">
                <div className="row mt-2">
                    <div className="col-sm-12">
                        <div className="background rounded p-3">
                            <div className="text-center mb-2">
                                <img src={LogoWebSai} alt="Logo" style={{width:150}}/>
                            </div>
                            <p className="text-center fw-bold fs-5 mb-0">LISTA DE EDIÇÕES</p>
                            <p className="text-center">Gerencie aqui as pesquisas WebSAI. Você pode atualizar aqui o período de aplicação das pesquisas</p>
                            <hr/>
                            <div className="bg-white rounded p-3 border text-center table-responsive">
                            <p className={loading ? '':'d-none'}>
                                {'Carregando... '}
                                <RotatingLines
                                    strokeColor="gray"
                                    strokeWidth="5"
                                    animationDuration="0.75"
                                    width="25"
                                    visible={loading}
                                />
                            </p>
                            <div className={loading ? "d-none":"mb-2 text-center"}>
                                <button className='btn btn-custom btn-sm' onClick={() => adicionarNovaEdicao(true)}>Adicionar Novo</button>
                            </div>
                            <div className={"bg-white rounded p-3 border mb-2"}>
                                <div className="input-group flex-nowrap">
                                    <span className="input-group-text" id="addon-wrapping"><BiSearch /></span>
                                    <input type="text" className="form-control" placeholder="Filtrar por descrição..." onChange={searchPesquisas}/>
                                    <button className="btn btn-outline-secondary" onClick={trocarExibir}>{todos ? "Exibir Todos" : "Exibir Vigentes"}</button>
                                </div>
                            </div>
                            <Table hover>
                                <tbody>
                                    {
                                        pesquisaFilter.map((pesquisa, key) => 
                                        <tr key={key}>
                                            <td className="text-start">
                                                <small className="fw-bolder">Descrição</small><br/>
                                                {pesquisa.descricao}
                                            </td>
                                            <td className="text-start">
                                                <small className="fw-bolder">Período de Vigência</small><br/>
                                                {dayjs(pesquisa.dtInicioEdicao).format("DD/MM/YYYY")} a {dayjs(pesquisa.dtFimEdicao).format("DD/MM/YYYY")}
                                            </td>
                                            <td className="text-start">
                                                <small className="fw-bolder">Vigente</small><br/>
                                                { pesquisa.vigente ? 'Sim':'Não'}
                                            </td>
                                            <td className="align-middle">
                                                <DropdownButton variant="secondary" id="dropdown-basic-button" title="Editar Edição" size="sm">
                                                    <Dropdown.Item onClick={() => editPesquisa(pesquisa)}>{pesquisa.vigente ? "Editar Pesquisas":"Visualizar Pesquisas"}</Dropdown.Item>
                                                    <Dropdown.Item onClick={() => editEdicao(pesquisa)} className={pesquisa.regLock ? "d-none":null}>Atualizar Edição</Dropdown.Item>
                                                </DropdownButton>
                                            </td>
                                        </tr>
                                        )
                                    }
                                </tbody>
                            </Table>

                            </div>

                            <hr/>
                            <div className="text-center mt-3">
                                <svg viewBox="0 0 1000 656.5" style={{width:70}}>
                                    <title>Centro Paula Souza</title>
                                    <path fill="#af0916" d="M760 181.2c.8-23.8 11.1-33.3 45.2-33.3H993V81.4H817c-83.2 0-130 35.6-130 103 0 131.5 240.1 104.6 240.1 174.3 0 23.8-12.7 36.5-45.2 36.5H636.3c24.8-30.3 40-69.4 40-114.1 0-112.5-72.9-207.5-196.4-207.5-111.7 0-191.7 84-191.7 209.1v31.1h-84.6c-65.7 0-130.7-42.8-130.7-123.6s65-123.6 130.7-123.6h53.9V0H191C102.2 0 0 68.1 0 190.1s102.2 190.1 190.9 190.1h97.3v276.2h69.7V380.2h132.7v-66.5H357.9v-18.4c0-104.6 55.5-155.3 122-155.3 74.5 0 126.7 54.6 126.7 132.3 0 66.7-36.1 110-93.3 122.8h-88.9v66.5H882c67.3 0 118-34.1 118-106.1 0-136.3-240.9-108.5-240-174.3" className="icon"></path>
                                    <path d="M481.6 560.8c-3.7 1.7-11.2 3.3-20.8 3.3-22.2 0-38.9-12.5-38.9-35.6 0-22 16.7-37 41.1-37 9.8 0 16 1.9 18.7 3.1l-2.4 7.4c-3.9-1.7-9.4-2.9-15.9-2.9-18.4 0-30.7 10.5-30.7 29 0 17.2 11.1 28.3 30.2 28.3 6.2 0 12.5-1.1 16.6-2.9l2.1 7.3zm16.8-21.2c.2 12.4 9.1 17.5 19.4 17.5 7.4 0 11.8-1.2 15.6-2.6l1.8 6.5c-3.6 1.5-9.8 3.1-18.8 3.1-17.4 0-27.8-10.2-27.8-25.5 0-15.2 10-27.2 26.5-27.2 18.4 0 23.3 14.5 23.3 23.8 0 1.9-.2 3.3-.4 4.3h-39.6zm30.1-6.6c.1-5.8-2.7-14.9-14.2-14.9-10.4 0-14.9 8.5-15.8 14.9h30zm22.6-6.7c0-5.2-.1-9.5-.5-13.7h9.1l.6 8.3h.2c2.8-4.8 9.3-9.5 18.7-9.5 7.8 0 20 4.2 20 21.5v30.2H589V534c0-8.1-3.4-14.9-13.1-14.9-6.8 0-12 4.3-13.8 9.4-.4 1.1-.7 2.7-.7 4.3v30.4h-10.3v-36.9zm76.8-28.2v14.5h14.7v7h-14.7v27.3c0 6.2 2 9.8 7.7 9.8 2.7 0 4.7-.3 6-.6l.5 6.9c-2 .7-5.1 1.3-9.1 1.3-4.8 0-8.6-1.4-11.1-3.9-2.9-2.7-4-7.2-4-13.1v-27.6h-8.8v-7h8.8v-12.1l10-2.5zm26.2 30.3c0-6-.1-11-.5-15.8h9l.3 9.9h.5c2.6-6.8 8.7-11.1 15.6-11.1 1.2 0 2 .1 2.9.3v8.6c-1-.2-2.1-.3-3.5-.3-7.2 0-12.4 4.9-13.8 11.8-.2 1.3-.5 2.7-.5 4.3V563h-10.2v-34.6zm88.2 9.1c0 18.7-14.5 26.8-28.1 26.8-15.3 0-27.1-10-27.1-26 0-16.9 12.4-26.8 28-26.8 16.2 0 27.2 10.5 27.2 26m-44.8.5c0 11.1 7.1 19.4 17.1 19.4 9.8 0 17.2-8.2 17.2-19.6 0-8.6-4.8-19.4-16.9-19.4-12.2 0-17.4 10-17.4 19.6m-270.9 47.3c4.9-.7 11.3-1.4 19.5-1.4 10 0 17.4 2.1 22.1 5.9 4.3 3.3 6.9 8.5 6.9 14.7 0 6.4-2.1 11.4-6.1 15-5.4 5.1-14.1 7.7-24 7.7-3 0-5.9-.1-8.2-.6v28.2h-10.2v-69.5zm10.1 33.9c2.2.5 5 .7 8.4.7 12.3 0 19.7-5.3 19.7-15 0-9.3-7.4-13.8-18.6-13.8-4.4 0-7.8.3-9.6.7v27.4zm79.9 35.6l-.8-6.4h-.3c-3.1 4-9.2 7.5-17.3 7.5-11.4 0-17.3-7.2-17.3-14.5 0-12.2 12.1-18.9 34-18.8v-1c0-4.2-1.3-11.7-12.8-11.7-5.3 0-10.7 1.5-14.7 3.7l-2.4-6.1c4.7-2.7 11.5-4.5 18.5-4.5 17.3 0 21.5 10.5 21.5 20.7v18.9c0 4.4.2 8.7.9 12.1h-9.3zm-1.5-25.8c-11.2-.2-23.9 1.6-23.9 11.4 0 5.9 4.4 8.8 9.7 8.8 7.4 0 12-4.2 13.7-8.4.4-1 .6-2 .6-2.9V629zm73.8 12c0 5.2.1 9.8.4 13.8h-9.1l-.6-8.2h-.2c-2.7 4.1-8.6 9.4-18.7 9.4-8.9 0-19.5-4.4-19.5-22.1v-29.5h10.3v28c0 9.6 3.3 16.1 12.6 16.1 6.9 0 11.7-4.3 13.5-8.3.6-1.4.9-3 .9-4.7v-31h10.3V641zm17-60.3h10.3v74.1h-10.3zm58.9 74.1l-.8-6.4h-.4c-3.1 4-9.2 7.5-17.3 7.5-11.4 0-17.3-7.2-17.3-14.5 0-12.2 12.1-18.9 34-18.8v-1c0-4.2-1.3-11.7-12.8-11.7-5.3 0-10.7 1.5-14.7 3.7l-2.3-6.1c4.7-2.7 11.4-4.5 18.6-4.5 17.3 0 21.5 10.5 21.5 20.7v18.9c0 4.4.2 8.7.9 12.1h-9.4zm-1.5-25.8c-11.2-.2-24 1.6-24 11.4 0 5.9 4.4 8.8 9.7 8.8 7.4 0 12-4.2 13.7-8.4.3-1 .6-2 .6-2.9V629zm50.2 14.7c4.5 2.5 11.2 4.6 18.2 4.6 10.4 0 16.5-4.9 16.5-12 0-6.6-4.2-10.3-14.8-14-12.9-4.1-20.8-10-20.8-19.9 0-11 10.1-19.1 25.4-19.1 8 0 13.9 1.7 17.4 3.4l-2.8 7.4c-2.6-1.2-7.8-3.3-15-3.3-10.7 0-14.8 5.7-14.8 10.5 0 6.6 4.8 9.8 15.7 13.6 13.3 4.6 20.1 10.3 20.1 20.7 0 10.9-9 20.2-27.6 20.2-7.6 0-15.9-2-20.1-4.5l2.6-7.6zm110.4-14.6c0 18.7-14.5 26.8-28.1 26.8-15.3 0-27.1-10-27.1-26 0-16.9 12.4-26.8 28-26.8 16.2 0 27.2 10.6 27.2 26m-44.8.5c0 11.1 7.1 19.4 17.2 19.4 9.8 0 17.2-8.3 17.2-19.6 0-8.5-4.8-19.4-16.9-19.4-12.3 0-17.5 10-17.5 19.6m105 11.4c0 5.2.1 9.8.5 13.8h-9.1l-.6-8.2h-.2c-2.7 4.1-8.6 9.4-18.7 9.4-8.9 0-19.5-4.4-19.5-22.1v-29.5h10.3v28c0 9.6 3.3 16.1 12.6 16.1 6.9 0 11.7-4.3 13.5-8.3.6-1.4.9-3 .9-4.7v-31h10.3V641zm10.7 8.5l25.6-29.8c2.4-2.7 4.8-5.1 7.3-7.8v-.2h-30.6v-7.4h43.1l-.1 5.8-25.2 29.3c-2.3 2.8-4.6 5.3-7.2 7.9v.2h33v7.3h-45.9v-5.3zm87.6 5.3l-.8-6.4h-.4c-3.1 4-9.2 7.5-17.3 7.5-11.5 0-17.3-7.2-17.3-14.5 0-12.2 12.1-18.9 34-18.8v-1c0-4.2-1.3-11.7-12.8-11.7-5.3 0-10.7 1.5-14.7 3.7l-2.3-6.1c4.7-2.7 11.4-4.5 18.6-4.5 17.3 0 21.5 10.5 21.5 20.7v18.9c0 4.4.2 8.7.9 12.1h-9.4zm-1.5-25.8c-11.2-.2-23.9 1.6-23.9 11.4 0 5.9 4.4 8.8 9.7 8.8 7.4 0 12-4.2 13.7-8.4.4-1 .6-2 .6-2.9V629z" className="title"></path>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <Modal size="xl" show={modal} onHide={() => controleModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{tituloEdicao}</Modal.Title>
                </Modal.Header>
                <Modal.Body>              
                    
                    <div className="input-group flex-nowrap mb-2">
                        <span className="input-group-text" id="addon-wrapping"><BiSearch /></span>
                        <input type="text" className="form-control" placeholder="Filtrar por grupo..." onChange={searchPesquisasForms}/>
                    </div>
                    {
                        vigente ?  
                        <div className={"mb-2 text-center"}>
                            <button className='btn btn-custom btn-sm' onClick={() => controleModalAplicacao(true,null,false)}>Adicionar Novo</button>
                        </div>
                        :null
                    }
                    <table className="table table-striped table-bordered table-hover table-sm">
                        <thead>
                            <th>Grupo</th>
                            <th>Formulário</th>
                            <th>Período de Aplicação</th>
                            <th></th>
                            {vigente ? <th></th> : null}
                        </thead>
                        <tbody>
                            <tr className={loadTableForm}>
                                <td colSpan={5} className="text-center">Carregando...</td>
                            </tr>
                            {
                                formulariosFilter.map((form,index) => 
                                    <tr>
                                        <td>{form.sistemaGrupo.descricao}</td>
                                        <td>
                                            {form.formulario.titulo}
                                        </td>
                                        <td>{dayjs(form.dtInicio).format("DD/MM/YYYY")} a {dayjs(form.dtFim).format("DD/MM/YYYY")}</td>
                                        <td>
                                            <div className="form-check">
                                                <input className="form-check-input" type="checkbox" checked={form.homologacao} disabled/>
                                                <label className="form-check-label">
                                                    Homologação
                                                </label>
                                            </div>
                                        
                                            <div className="form-check">
                                                <input className="form-check-input" type="checkbox" checked={form.ativo} disabled/>
                                                <label className="form-check-label">
                                                    Ativo
                                                </label>
                                            </div>
                                        </td>
                                        {
                                        vigente ?
                                        <td>
                                            <div className="btn-group">
                                                <button className="btn btn-warning btn-sm" onClick={() => controleModalAplicacao(true,index, true)}><MdEditSquare/> Editar</button>
                                                {
                                                dayjs(form.dtInicio) >= dayjs(dtAtual) ? 
                                                <button className="btn btn-danger btn-sm" onClick={() => delFormGrupo(form.formularioGrupoId)}><BiTrash /> Excluir</button>
                                                :null
                                                }
                                            </div>
                                        </td>
                                        :null
                                        }
                                    </tr>
                            )}
                        </tbody>
                    </table>
                    
                </Modal.Body>
            </Modal>


            {
                typeof inputs.sistemaGrupo !== "undefined" ?
                <Modal size="xl" show={modalAplicacao} onHide={() => controleModalAplicacao(false,null,null)}>
                    <Modal.Header closeButton>
                        <Modal.Title>{isUpdate ? 'Editar Aplicação: ' + inputs.sistemaGrupo.descricao : 'Adicionar Aplicação'}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <form onSubmit={handleSubmit}>
                            <div className="row">
                                {
                                    isUpdate ?
                                    <div className="mb-2 col-lg-6">
                                        <label htmlFor="idunidade">Selecione o grupo</label>
                                        <input type="text" value={inputs.sistemaGrupo.descricao} name="descricaoGrupo" className="form-control" disabled/> 
                                    </div>
                                    :
                                    <div className="mb-2 col-lg-6">
                                        <label htmlFor="idunidade">Selecione o grupo</label>
                                        <Select
                                            options={listaGrupos}
                                            onChange={setSelectedOptionGrupo}
                                            placeholder={loadingListaGrupos ? "Carregando..." : "Selecione..."}
                                        />
                                        <span className='text-danger'>{error.grupo}</span>

                                    </div>
                                }
                                <div className="mb-2 col-lg-6">
                                <label htmlFor="idunidade">Selecione o formulário</label>
                                    <Select
                                        options={listaFormularios}
                                        onChange={setSelectedOptionForm}
                                        placeholder={loadingListaForm ? "Carregando..." : "Selecione..."}
                                        defaultValue={{label:inputs.formulario.titulo, value:inputs.formulario.formularioId}}
                                    />
                                    <span className='text-danger'>{error.formulario}</span>
                                </div>
                                <div className="mb-2 col-lg-6">
                                    <label>Início da Pesquisa</label>
                                    <input type="date" value={dayjs(inputs.dtInicio).format("YYYY-MM-DD")} name="dtInicio" className="form-control" onChange={handledChange} disabled={isUpdate && compareDates(inputs.dtInicio) ? false : !isUpdate ? false : true}/> 
                                    <span className='text-danger'>{error.dtInicio}</span>
                                </div>
                                <div className="mb-2 col-lg-6">
                                    <label>Término da Pesquisa</label>
                                    <input type="date" value={dayjs(inputs.dtFim).format("YYYY-MM-DD")} name="dtFim" className="form-control" onChange={handledChange}/> 
                                    <span className='text-danger'>{error.dtFim}</span>
                                </div>  

                                <div>
                                    <div className="form-check form-check-inline">
                                        <input className="form-check-input" type="checkbox" name="homologacao" value={inputs.homologacao?false:true} onChange={handledChange} checked={inputs.homologacao}/>
                                        <label clclassNameass="form-check-label">Homologação</label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input className="form-check-input" type="checkbox" name="ativo" value={inputs.ativo?false:true} onChange={handledChange} checked={inputs.ativo}/>
                                        <label clclassNameass="form-check-label">Ativo</label>
                                    </div>
                                </div>

                            </div>
                            <div className="btn-group mt-2" role="group" aria-label="Basic example">
                                <button type="submit" className="btn btn-custom">Gravar</button>
                                <button type="button" className="btn btn-light border" onClick={() => controleModalAplicacao(false,null,null)}>Fechar</button>
                            </div>
                        </form>                
                    </Modal.Body>
                </Modal>
                :null
            }


                <Modal size="lg" show={modalEdicao} onHide={() => controleModalEdicao(false)}>
                    <Modal.Header closeButton>
                        <Modal.Title>{inputs.edicaoId !== null ? "Atualizar Edição: "+inputs.descricao:"Adicionar Edição"}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <form onSubmit={submitEdicao}>
                            <div className="row">
                                <div className="mb-2 col-lg-6">
                                    <label>Título</label>
                                    <input type="text" name="descricao" value={inputs.descricao} className="form-control" onChange={handledChange} disabled/> 
                                    <span className='text-danger'>{error.descricao}</span>
                                </div>
                                <div className="mb-2 col-lg-6">
                                    <label>Ano Edição</label>
                                    <input type="number" name="anoEdicao" value={inputs.anoEdicao} className="form-control" onChange={handledChange}/> 
                                    <span className='text-danger'>{error.anoEdicao}</span>
                                </div>
                                <div className="mb-2 col-lg-6">
                                    <label>Início Egresso</label>
                                    <input type="date" name="dtInicioEgresso" value={dayjs(inputs.dtInicioEgresso).format("YYYY-MM-DD")} className="form-control" onChange={handledChange}/> 
                                    <span className='text-danger'>{error.dtInicioEgresso}</span>
                                </div>
                                <div className="mb-2 col-lg-6">
                                    <label>Fim Egresso</label>
                                    <input type="date" name="dtFimEgresso" value={dayjs(inputs.dtFimEgresso).format("YYYY-MM-DD")} className="form-control" onChange={handledChange}/> 
                                    <span className='text-danger'>{error.dtFimEgresso}</span>
                                </div> 
                                <div>
                                    <div className="form-check form-check-inline">
                                        <input className="form-check-input" type="checkbox" name="vigente" value={inputs.vigente?false:true} onChange={handledChange} checked={inputs.vigente}/>
                                        <label clclassNameass="form-check-label">Vigente</label>
                                    </div>
                                </div>

                            </div>
                            <div className="btn-group mt-2" role="group" aria-label="Basic example">
                                <button type="submit" className="btn btn-custom">Gravar</button>
                                <button type="button" className="btn btn-light border" onClick={() => controleModalEdicao(false)}>Fechar</button>
                            </div>
                        </form>                
                    </Modal.Body>
                </Modal>

        </div>
    )
    
}